export const Label = ({ htmlFor, children, className }) => {
  return (
    <div className={className}>
      <label htmlFor={htmlFor}>{children}</label>
    </div>
  );
};
